import BaseRepository from './BaseRepository';

export default class InsuranceRepository extends BaseRepository
{
    getEndpoint()
    {
        return 'v1/insurance';
    }

    getAvailableInsurances(reservationId)
    {
        return this.request('GET', `${this.getEndpoint()}/available-insurances/${reservationId}`, null);
    }

    requestInsurance(data)
    {
        return this.request('POST', `${this.getEndpoint()}/request`, data);
    }
}
